import React , {Fragment} from 'react'
import { Field, reduxForm } from 'redux-form'
import _ from "lodash";
import {connect} from 'react-redux' ;
import {simpleInputField , inputWithUnit , selectField , textAreaField , uploadFileField} from "../components/InputRenderers";
import LoadingIcon from '../../img/three-dots.svg' ;

const validate = (values) => {
    const errors = {};
    if (!values.name || values.name === '') {
        errors.name = "لطفا عنوان کتاب را وارد کنید" ;
    }
    if (!values.price || values.price === '') {
        errors.price = "لطفا قیمت را وارد کنید" ;
    }
    else if (!/^[0-9]*$/gm.test(values.price)) {
        errors.price = "قیمت معتبر نیست" ;
    }
    if (!values.authorName || values.authorName === '') {
        errors.authorName = "لطفا نام نویسندگان را وارد کنید" ;
    }
    if (!values.publisher || values.publisher === '') {
        errors.publisher = "لطفا نام ناشران را وارد کنید" ;
    }
    if (!values.isbn || values.isbn === '') {
        errors.isbn = "لطفا ISBN را وارد کنید" ;
    }
    if (!values.category) {
        errors.category = "لطفا یک دسته بندی را انتخاب کنید" ;
    }
    if (!values.thumbnailId) {
        errors.thumbnailId = 'لطفا یک عکس آپلود کنید' ;
    }
    return errors;
};

export const categoryOptions = (bookCategories) => {
    return _.map(bookCategories.data , category => {
        return {
            value : category.id ,
            label : category.name
        };
    }) ;
};

let AddOrEditBookForm = props => {
    const { handleSubmit, error, loading , bookCategories , isAdd} = props;
    return (
        <Fragment>
            <div className="sizeHandler_1185">
                <div className="addBookForm">
                    {/*<div className="bookCoverUpload">*/}
                        {/*<div className="uploadContent">*/}
                        {/*    <span className="icon icon-camera"></span>*/}
                        {/*    <p>آپلود عکس جلد کتاب</p>*/}
                        {/*    <div className="organizer">*/}
                        {/*        <div className="normalButton fillMode originalButton">*/}
                        {/*            <span className="icon icon-upload font-size_18 middleContext"></span> آپلود عکس*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <Field name="thumbnailId" component={uploadFileField} label="آپلود عکس کتاب"/>
                    {/*</div>*/}
                    <div className="addBookColumn">
                        <div className="formContainer">
                            <Field name="name" component={simpleInputField} label="عنوان کتاب" />
                            <Field name="price" component={inputWithUnit} label="قیمت" unit="تومان"/>
                            <Field name="authorName" component={simpleInputField} label="نویسندگان"/>
                            <Field name="publisher" component={simpleInputField} label="ناشر"/>
                            <Field name="translators" component={simpleInputField} label="مترجمین"/>
                            <Field name="category" component={selectField} options={categoryOptions(bookCategories)} label="دسته بندی"/>
                            <Field name="isbn" component={simpleInputField} label="ISBN"/>
                            <Field name="description" component={textAreaField} label="توضیحات"/>
                            {/*<div className="normalButton outlineMode greenButton"><span*/}
                            {/*    className="icon icon-add font-size_14 middleContext"></span> اضافه به لیست*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
                {/*<div className="addedBooksTitle organizer boldFont font-size_18">کتاب های اضافه شده</div>*/}
                {/*<div className="addedBooks organizer">*/}
                {/*    <div className="bookBox centerText">*/}
                {/*        <span className="icon icon-close"></span>*/}
                {/*        <div className="saveBookImage blockInline">*/}
                {/*            <img src={bestSellBook} />*/}
                {/*        </div>*/}
                {/*        <div className="savedBookTitle">هوش هیجانی برای مدیران پروژه</div>*/}
                {/*    </div>*/}
                {/*    <div className="bookBox centerText">*/}
                {/*        <span className="icon icon-close"></span>*/}
                {/*        <div className="saveBookImage blockInline">*/}
                {/*            <img src={bestSellBook} />*/}
                {/*        </div>*/}
                {/*        <div className="savedBookTitle">هوش هیجانی برای مدیران پروژه</div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            <div className="maximumSizeHandler">
                <div className="confirmAll organizer">
                    <span className="lineSeparator"></span>
                    <div className="organizer centerText">
                        <div className="confirmationButton clickShape" onClick={handleSubmit}>
                            <span className="buttonText rightFloat">{isAdd ? `تایید` : `به روز رسانی`}</span>
                            {loading? <img src={LoadingIcon}/> :<span className="icon icon-check leftFloat"></span>}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    bookCategories : state.bookCategories
});

const form = connect(mapStateToProps)(AddOrEditBookForm);

const AddOrEditBook = reduxForm({
    // a unique name for the form
    enableReinitialize: true ,
    form: "AddOrEditBook",
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
})(form);

export default AddOrEditBook;